import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Contact({
  user,
  firstName = '',
  lastName = '',
  companyId = '',
  email = '',
  title = '',
  phone = '',
  tags = [],
  disableInput = false,
  permissionPrefix,
  onUpdate = () => {},
}) {
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  const onChangeTag = (data) => {
    onUpdate(data);
  };

  return (
    <div className="Information info-user">
      <Grid spacing={2} container>
        <Grid size={6}>
          <Field
            type="text"
            label="First Name"
            name="fname"
            placeholder="First Name"
            value={firstName}
            tabIndex={1}
            disabled={disableInput}
            testId="user-contact-first-name-input"
            onChange={onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Last Name"
            name="lname"
            placeholder="Last Name"
            value={lastName}
            tabIndex={2}
            disabled={disableInput}
            testId="user-contact-last-name-input"
            onChange={onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Title"
            name="title"
            placeholder="Title"
            value={title}
            tabIndex={5}
            disabled={disableInput}
            testId="user-contact-title-input"
            onChange={onChange}
          />
        </Grid>

        <Grid size={6} />

        <Grid size={6}>
          <Field
            type="text"
            label="Email"
            name="email"
            placeholder="user@example.com"
            value={email}
            tabIndex={4}
            disabled={disableInput}
            testId="user-contact-email-input"
            onChange={onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="phone"
            label="Phone"
            name="phone"
            value={phone}
            tabIndex={6}
            disabled={disableInput}
            testId="user-contact-phone-input"
            onChange={onChange}
          />
        </Grid>

        <Grid size={12}>
          <Field
            type="tags"
            label="Tags"
            name="tags"
            tagProps={{
              companyId,
              tags,
              allowTypes: ['client', 'admin'],
              showAs: 'list',
              assign: user.can(`${permissionPrefix}.assign_tag`),
            }}
            disabled={disableInput}
            testId="user-contact-tags-input"
            onChange={onChangeTag}
            tabIndex={7}
          />
        </Grid>
      </Grid>
    </div>
  );
}

Contact.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  title: PropTypes.string,
  companyId: PropTypes.string,
  phone: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  disableInput: PropTypes.bool,
  permissionPrefix: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Contact);
